import DynamicFormContactResourceModel from '../../generated/types/model/resource/DynamicFormContactResourceModel';

export default class DynamicFormContactResourceViewModel extends DynamicFormContactResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
